//-----------------------------------------------------------------------------
// Third-party libraries
//-----------------------------------------------------------------------------


//-----------------------------------------------------------------------------
// GOV.UK design system
//-----------------------------------------------------------------------------

const GOVUKFrontend = require("govuk-frontend");
GOVUKFrontend.initAll();


//-----------------------------------------------------------------------------
// Components
//-----------------------------------------------------------------------------

require("./components/auth-action");
require("./components/password-toggle");
require("./components/session-timeout");
require("./components/toggle-content");


//-----------------------------------------------------------------------------
// Feedback
//-----------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  window.appFrontendLoaded = true;
});
